module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/sections/images/i18n/sl.json
// module id = g/zM
// module chunks = 13